<div class="company-select">
  <div class="user-content" :class="isError ? 'is-error': ''">
    <div class="user-list">
      <span v-if="!value">请选择</span>
      <a-tag class="company-name" v-else closable color="blue" @close.prevent="removeSelected">{{ valueName }}</a-tag>
    </div>
    <div @click="showModal" class="add-icon">
      <img src="../../assets/images/icon_add.png" />
    </div>
  </div>

  <a-modal
    v-model:visible="visible"
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    title="选择往来单位"
    width="1000px"
    @cancel="closeModal"
    @ok="ok"
  >
    <a-form layout="inline">
      <a-form-item>
        <a-input
          v-model:value.trim="queryRef.companyName"
          allow-clear
          placeholder="请输入往来单位名称关键字"
          style="width: 250px"
        ></a-input>
      </a-form-item>

      <a-form-item>
        <company-type-select
          v-model:value="queryRef.cooperationCompanyTypeIds"
          placeholder="请选择往来单位类别"
          width="300px"
        ></company-type-select>
      </a-form-item>

      <a-form-item>
        <a-button @click="reset" style="margin-left: 14px !important">重置</a-button>
        <a-button :loading="loading" type="primary" @click="search">查询</a-button>
      </a-form-item>
    </a-form>

    <!-- <a-table
      :bordered="true"
      :columns="columns"
      :data-source="dataSource"
      :loading="loading"
      :pagination="pagination"
      :row-selection="{
        selectedRowKeys: selectedKeys,
        onChange: onSelectionChange,
        fixed: true,
        type: 'radio'
      }"
      :scroll="{ x: 1100 }"
      class="mt15"
      row-key="id"
      size="small"
      @change="onTableChange"
    > -->
    <table-wrapper
      :dataSource="dataSource"
      @onTableChange="onTableChange"
      @onRadioChange="onRadioChange"
      :pagination="pagination"
      :loading="loading"
      :columns="columns"
      :showRadiobox="true"
    >
      <template #cooperationCompanyTypeNames="{ record } ">
        <array-description :data-source="record?.cooperationCompanyTypeNames"></array-description>
      </template>
      <template #location="{ record }">
        <location-description :record="record"></location-description>
      </template>
    </table-wrapper>
  </a-modal>
</div>
